import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-col gap-y-6" }
const _hoisted_3 = { class: "flex flex-col gap-y-3" }
const _hoisted_4 = { class: "flex items-center gap-x-2 justify-between" }
const _hoisted_5 = { class: "flex flex-col gap-y-3" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col gap-y-2"
}
const _hoisted_7 = { class: "flex items-center gap-x-2 justify-start" }

import { ref, watch, onMounted } from "vue"
import GgmsDropdown from "@/components/GgmsDropdown.vue"
import GgmsRadioSelect from "@/components/GgmsRadioSelect.vue"
import { useWorkflowStore } from "@/stores/workflow"
import GgmsCommaInput from "@/components/GgmsCommaInput.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ThrottleSidebarComponent',
  emits: ["changeAction"],
  setup(__props) {


const workflowStore = useWorkflowStore()

const throttleCount = ref(100)
const throttlePeriod = ref(1)
const throttleUnit = ref("minutes")

const terminationType = ref("allContactsProcessed")
const terminationValue = ref(60)
const terminationUnit = ref("minutes elapsed")

const throttleUnitOptions = [
    { label: "Minute/s", value: "minutes" },
    { label: "Hour/s", value: "hours" },
]

const terminationOptions = [
    { displayName: "All contacts processed", value: "allContactsProcessed" },
    { displayName: "Custom limit", value: "custom" },
]

const terminationUnitOptions = [
    { label: "Minutes elapsed", value: "minutes elapsed" },
    { label: "Hours elapsed", value: "hours elapsed" },
    { label: "Contacts processed", value: "contacts processed" },
]

function validateAndUpdateButtons() {
    const throttleCountValue = Number(throttleCount.value)
    const isValidThrottleCount = isNaN(throttleCountValue) || throttleCountValue > 0

    let isValidTermination = true

    if (terminationType.value === "custom") {
        const terminationValueValue = Number(terminationValue.value)
        isValidTermination = isNaN(terminationValueValue) || terminationValueValue > 0
    }

    const isValid = isValidThrottleCount && isValidTermination
    workflowStore.areButtonDisabled = !isValid
}

watch(
    [throttleCount, throttlePeriod, throttleUnit, terminationType, terminationValue, terminationUnit],
    () => {
        workflowStore.modelValue = {
            throttle: {
                count: throttleCount.value,
                period: throttlePeriod.value,
                unit: throttleUnit.value,
            },
            termination: {
                type: terminationType.value,
                ...(terminationType.value === "custom" && {
                    value: terminationValue.value,
                    unit: terminationUnit.value,
                }),
            },
        }
        validateAndUpdateButtons()
    },
    { deep: true }
)

onMounted(() => {
    if (workflowStore.modelValue?.throttle) {
        throttleCount.value = workflowStore.modelValue.throttle.count
        throttlePeriod.value = workflowStore.modelValue.throttle.period || 1
        throttleUnit.value = workflowStore.modelValue.throttle.unit
    }

    if (workflowStore.modelValue?.termination) {
        terminationType.value = workflowStore.modelValue.termination.type
        if (workflowStore.modelValue.termination.type === "custom") {
            terminationValue.value = workflowStore.modelValue.termination.value || 60
            terminationUnit.value = workflowStore.modelValue.termination.unit || "minutes elapsed"
        }
    }

    workflowStore.modelValue = {
        throttle: {
            count: throttleCount.value,
            period: throttlePeriod.value,
            unit: throttleUnit.value,
        },
        termination: {
            type: terminationType.value,
            ...(terminationType.value === "custom" && {
                value: terminationValue.value,
                unit: terminationUnit.value,
            }),
        },
    }

    validateAndUpdateButtons()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-lg leading-7 font-medium text-black" }, "Add a throttle between actions.", -1)),
    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-sm text-gray-700 pb-6" }, " Control how many contacts are processed and when the workflow should end. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm font-medium text-gray-700" }, "Process contacts", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(GgmsCommaInput, {
            modelValue: throttleCount.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((throttleCount).value = $event)),
            placeholder: "100",
            class: "w-20"
          }, null, 8, ["modelValue"]),
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-sm text-gray-700" }, "every", -1)),
          _createVNode(GgmsCommaInput, {
            modelValue: throttlePeriod.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((throttlePeriod).value = $event)),
            placeholder: "1",
            class: "w-20"
          }, null, 8, ["modelValue"]),
          _createVNode(GgmsDropdown, {
            modelValue: throttleUnit.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((throttleUnit).value = $event)),
            options: throttleUnitOptions,
            optionLabel: "label",
            optionValue: "value",
            class: "w-40"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-sm font-medium text-gray-700" }, "End workflow after", -1)),
        _createVNode(GgmsRadioSelect, {
          modelValue: terminationType.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((terminationType).value = $event)),
          options: terminationOptions
        }, null, 8, ["modelValue"]),
        (terminationType.value === 'custom')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(GgmsCommaInput, {
                  modelValue: terminationValue.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((terminationValue).value = $event)),
                  placeholder: "60",
                  class: "w-32"
                }, null, 8, ["modelValue"]),
                _createVNode(GgmsDropdown, {
                  modelValue: terminationUnit.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((terminationUnit).value = $event)),
                  options: terminationUnitOptions,
                  optionLabel: "label",
                  optionValue: "value",
                  class: "w-64 ml-1"
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})